export default {
      id: "log-usage",
      viewBox: "0 0 25.74 25",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#log",
      toString: function () {
        return this.url;
      }
    }